import type { FilmRole } from "@/types/film";

interface RoleListProps {
  roles: FilmRole[];
}

export default function RoleList({ roles }: RoleListProps) {
  return (
    <section className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
          <span className="h-4 w-[3px] rounded-full bg-accent-500" />
          角色分析
        </h2>
        <span className="text-xs text-foreground-400">共 {roles.length} 位主要人物</span>
      </div>

      <ul className="mt-5 space-y-4">
        {roles.map((role, index) => (
          <li key={role.name} className="flex gap-4 rounded-md bg-background-100 p-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-sm text-background-50">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div className="min-w-0">
              <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 md:text-base">{role.name}</h3>
                <span className="text-[11px] text-foreground-500">由 {role.actor} 饰演</span>
              </div>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{role.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}